import React from "react";
import { Text, View, Image } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";
import { formatPrintDate } from "../formatPrintDate";

const PrintSection1 = ({ section1 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 1 – Applicant Details
      </Text>
      <View style={PrintApplicationStyles.inputtable}>
        {/* First Row - Full Name Label */}
        <Text style={PrintApplicationStyles.labelCellHeader}>
          1.1 Full Name
        </Text>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            {/* Title Row */}
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Title</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.title || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Surname</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.surname || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Forename</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.forename || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Other Names</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.otherNames || ""}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <Text style={PrintApplicationStyles.labelCellHeader}>
          1.2 Previous name – if you are known, or have been known, by any other
          names or have a former name (s), or surname (s), please enter full
          details
        </Text>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Former name (s)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.formerNames || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Date of name change
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {formatPrintDate(section1?.personalDetails?.nameChangeDate)}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Reason for name change
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.personalDetails?.reasonForNameChange || ""}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <Text style={PrintApplicationStyles.labelCellHeader}>
          1.3 Contact details
        </Text>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Home Telephone
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.homeTelephone || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Office Telephone
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.officeTelephone || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Mobile Telephone
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.mobileTelephone || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Email Address
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.emailAddress || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Can we use same contact details for post-appointment
                communication?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.useSameDeatilsPostAppointment ===
                  true
                    ? "Yes"
                    : section1?.personalDetails
                          .useSameDeatilsPostAppointment === false
                      ? "No"
                      : section1?.personalDetails
                            .useSameDeatilsPostAppointment === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Please provide Contact details
              </Text>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Mobile Number
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.postAppointmentMobileTelephone ||
                    ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Email Address
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text style={PrintApplicationStyles.inputLabel}>
                  {section1?.personalDetails?.postAppointmentEmailAddress || ""}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <Text style={PrintApplicationStyles.labelCellHeader}>
          POST APPOINTMENT CONTACT DETAILS - This will be used for all future
          communication
        </Text>
        <Text style={PrintApplicationStyles.labelCellHeader}>
          1.4 Current Address
        </Text>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Address</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section1?.personalDetails?.currentAddress || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Town</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section1?.personalDetails?.currentTown || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>County</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section1?.personalDetails?.currentCounty || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>Postcode</Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section1?.personalDetails?.currentPostcode || ""}</Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Month/Year of Move In
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text style={PrintApplicationStyles.inputLabel}>
                {formatPrintDate(section1?.personalDetails?.movingInDate)}
              </Text>
            </View>
          </View>
        </View>

        <Text style={PrintApplicationStyles.content}>
          1.5 Previous Address (es)
        </Text>
        {/* <Text style={PrintApplicationStyles.labelCellHeader}>
                    If you have not resided at your current address for more than five
                    years, please enter previous addresses
                  </Text> */}
        {section1?.previousAddress &&
        Object.keys(section1.previousAddress).length > 0 ? (
          Object.values(section1.previousAddress).map((address, index) => (
            <View style={PrintApplicationStyles.tableRow} key={index}>
              <View style={PrintApplicationStyles.tableRow}>
                <View style={PrintApplicationStyles.inputSection}>
                  <View style={PrintApplicationStyles.inputRow}>
                    <Text style={PrintApplicationStyles.inputLabel}>
                      Address
                    </Text>
                    <View style={PrintApplicationStyles.inputBox}>
                      <Text>{address?.address || ""}</Text>
                    </View>
                  </View>

                  <View style={PrintApplicationStyles.inputRow}>
                    <Text style={PrintApplicationStyles.inputLabel}>Town</Text>
                    <View style={PrintApplicationStyles.inputBox}>
                      <Text>{address?.town || ""}</Text>
                    </View>
                  </View>

                  <View style={PrintApplicationStyles.inputRow}>
                    <Text style={PrintApplicationStyles.inputLabel}>
                      County
                    </Text>
                    <View style={PrintApplicationStyles.inputBox}>
                      <Text>{address?.county || ""}</Text>
                    </View>
                  </View>
                  <View style={PrintApplicationStyles.inputRow}>
                    <Text style={PrintApplicationStyles.inputLabel}>
                      Postcode
                    </Text>
                    <View style={PrintApplicationStyles.inputBox}>
                      <Text>{address?.postcode || ""}</Text>
                    </View>
                  </View>

                  <View style={PrintApplicationStyles.inputRow}>
                    <Text style={PrintApplicationStyles.inputLabel}>From</Text>
                    <View style={PrintApplicationStyles.inputBox}>
                      <Text>
                        {formatPrintDate(address?.from)}
                      </Text>
                    </View>
                  </View>
                  <View style={PrintApplicationStyles.inputRow}>
                    <Text style={PrintApplicationStyles.inputLabel}>To</Text>
                    <View style={PrintApplicationStyles.inputBox}>
                      <Text>
                        {formatPrintDate(address?.to)}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
            </View>
          ))
        ) : (
          <Text>No previous addresses provided.</Text>
        )}

        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.6 Date of Birth
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {formatPrintDate(section1?.personalDetails?.dob)}
                </Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.7 Please confirm that you give consent for a Disclosure and
                Barring Service (DBS check)
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.personalDetails
                    ?.consentToDisclosureScotlandCheck === true
                    ? "Yes"
                    : section1?.personalDetails
                          .consentToDisclosureScotlandCheck === false
                      ? "No"
                      : section1?.personalDetails
                            .consentToDisclosureScotlandCheck === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.8 National Insurance Number
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.personalDetails?.nationalInsuranceNumber || ""}
                </Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If you have a temporary National Insurance number, have you
                applied for a permanent number?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.personalDetails.tempNationalInsuranceNumber ===
                  true
                    ? "Yes"
                    : section1?.personalDetails.tempNationalInsuranceNumber ===
                        false
                      ? "No"
                      : section1?.personalDetails
                            .tempNationalInsuranceNumber === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View style={PrintApplicationStyles.inputRow}>
          <Text>
            NB: If you are not British, nor an EU citizen, please provide proof
            of indefinite right to remain and work in the UK. Acceptable proof
            is your original passport or original correspondence from the Home
            Office
          </Text>
        </View>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.9 Nationality at birth
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.personalDetails?.nationalityAtBirth || ""}
                </Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.10 Have you changed your nationality since birth, if so please
                provide your current nationality
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.personalDetails?.changedNationality}</Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.11 Town of Birth
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.personalDetails?.townOfBirth || ""}</Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.12 Country of Birth
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.personalDetails?.countryOfBirth || ""}</Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.13 If born outside the EU, how long have you lived in the UK?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {formatPrintDate(section1?.personalDetails?.durationInUk)}
                </Text>
              </View>
            </View>

            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.14. Mother’s maiden name
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.personalDetails?.mothersMaidenName || ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.15 What are you applying as?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {Array.isArray(section1.applicationDetails.applyingAs)
                    ? section1.applicationDetails.applyingAs.join("\n") // If it's an array, join with newline
                    : section1.applicationDetails.applyingAs || ""}{" "}
                </Text>

                {/* {section1?.applicationDetails?.applyingAs?.length > 0 ? (
                          <Text style={PrintApplicationStyles.inputLabel}>
                            {section1.applicationDetails.applyingAs.join(", ")}
                          </Text>
                        ) : (
                          <Text style={PrintApplicationStyles.inputLabel}></Text>
                        )} */}
              </View>
            </View>
          </View>
        </View>

        {(Array.isArray(section1?.applicationDetails?.applyingAs)
          ? section1.applicationDetails.applyingAs.includes(
              "Non-Selling Principal",
            )
          : section1?.applicationDetails?.applyingAs ===
            "Non-Selling Principal") && (
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              1.16 What business areas will the appointed representative advise
              on?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {Array.isArray(section1.applicationDetails.businessAreas)
                  ? section1.applicationDetails.businessAreas.join("\n")
                  : section1.applicationDetails.businessAreas || ""}{" "}
              </Text>
            </View>
          </View>
        )}

        {(Array.isArray(section1?.applicationDetails?.applyingAs)
          ? section1.applicationDetails.applyingAs.includes("Selling Principal")
          : section1?.applicationDetails?.applyingAs ===
            "Selling Principal") && (
          <View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.16.1 What business areas will you advise on?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {Array.isArray(section1.applicationDetails.businessAreas)
                    ? section1.applicationDetails.businessAreas.join("\n")
                    : section1.applicationDetails.businessAreas || ""}{" "}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                1.16.2 What business areas will the appointed representative
                advise on?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {Array.isArray(section1.applicationDetails.ARBusinessAreas)
                    ? section1.applicationDetails.ARBusinessAreas.join("\n")
                    : section1.applicationDetails.ARBusinessAreas || ""}{" "}
                </Text>
              </View>
            </View>
          </View>
        )}

        {(Array.isArray(section1?.applicationDetails?.applyingAs)
          ? section1.applicationDetails.applyingAs.includes("Adviser")
          : section1?.applicationDetails?.applyingAs === "Adviser") && (
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              1.16 What business areas will you advise on?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {Array.isArray(section1.applicationDetails.businessAreas)
                  ? section1.applicationDetails.businessAreas.join("\n")
                  : section1.applicationDetails.businessAreas || ""}{" "}
              </Text>
            </View>
          </View>
        )}

        {/* <View style={PrintApplicationStyles.inputRow}>
                  <Text style={PrintApplicationStyles.inputLabel}>
                    1.16 What business areas will you advise on?
                  </Text>
                  <View style={PrintApplicationStyles.inputBox}>
                    <Text>
                      {Array.isArray(section1.applicationDetails.businessAreas)
                        ? section1.applicationDetails.businessAreas.join("\n") // If it's an array, join with newline
                        : section1.applicationDetails.businessAreas || ""}{" "}
                    </Text>
                  </View>
                </View> */}
        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>
            1.17 Are you applying to join:
          </Text>
          <View style={PrintApplicationStyles.inputBox}>
            <Text>{section1?.applicationDetails?.applyingToJoin || ""}</Text>
          </View>
        </View>

        <View style={PrintApplicationStyles.inputRow}>
          <Text style={PrintApplicationStyles.inputLabel}>
            Name of Appointed Representative or Trading Style
          </Text>
          <View style={PrintApplicationStyles.inputBox}>
            <Text>{section1?.applicationDetails?.tradingStyle || ""}</Text>
          </View>
        </View>
        <View style={PrintApplicationStyles.inputRow}>
          <Text>
            (THIS IS VERY IMPORTANT – IT IS EXACTLY WHAT WILL BE SHOWN ON THE
            FCA REGISTER)
          </Text>
        </View>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Will you be conducting Pension transfer business as part of your
                proposition?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.applicationDetails?.pensionTransferBusiness ===
                  true
                    ? "Yes"
                    : section1?.applicationDetails.pensionTransferBusiness ===
                        false
                      ? "No"
                      : section1?.applicationDetails.pensionTransferBusiness ===
                          "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Will you be conducting Mortgage planning business as part of
                your proposition?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.applicationDetails?.mortgagePlanningBusiness ===
                  true
                    ? "Yes"
                    : section1?.applicationDetails.mortgagePlanningBusiness ===
                        false
                      ? "No"
                      : section1?.applicationDetails
                            .mortgagePlanningBusiness === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Have you ever referred business or Introduced business to
                another adviser?
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.applicationDetails.referredBusiness === true
                    ? "Yes"
                    : section1?.applicationDetails.referredBusiness === false
                      ? "No"
                      : section1?.applicationDetails.referredBusiness === "N/A"
                        ? "Not Applicable"
                        : ""}
                </Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                If yes, please provide us with further information on volumes
                and the types of business involved. (As of November 2021, the
                FCA authorisations team has informed us they require detailed
                information on this point. Please provide full details to avoid
                your application being unnecessarily delayed).
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>
                  {section1?.applicationDetails?.referredBusinessDetails || ""}
                </Text>
              </View>
            </View>
          </View>
        </View>
        <View style={PrintApplicationStyles.inputRow}>
          <Text>1.18 Next of Kin Details</Text>
        </View>
        <View style={PrintApplicationStyles.tableRow}>
          <View style={PrintApplicationStyles.inputSection}>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Name</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.name || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Address</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.address || ""}</Text>
              </View>
            </View>
            {/* Forename Row */}
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Town</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.town || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>County</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.county || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Postcode</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.postcode || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Email Address
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.email || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Contact Telephone Number
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.telephone || ""}</Text>
              </View>
            </View>
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>
                Relationship with next of kin
              </Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section1?.nextOfKinDetails?.relationship || ""}</Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default PrintSection1;
